module.exports = __webpack_public_path__ + "static/img/qp1.057741f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qp1.png
// module id = jaYn
// module chunks = 2